import { MinusCircleOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Col, DatePicker, Form, Input, message, Row, Select, Upload } from 'antd';
import { debounce } from 'lodash';
import dayjs from 'dayjs';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { ReactComponent as Back } from '../../../Images/Back.svg';
import AutoOpenSelect from '../../SelectComponent/AutoOpenSelect';
import { fetchPackingModeList, resetPackingModeData } from '../../../slices/packing';
import { fetchAlloysList, resetAlloyList } from '../../../slices/alloy';
import { fetchTempersList, resetCurrentTemperPage, resetTempersList } from '../../../slices/tempers';
import { fetchjobWorkList, resetJobWorkList } from '../../../slices/job-work';
import { fetchInquiryQuotationById } from '../../../slices/inquiry-quotation';
import { convertToSalesOrder } from '../../../slices/sales-order';
import moment from 'moment';

const { Option } = Select;

function ConvertToSalesOrder() {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const [form] = Form.useForm();
  useEffect(() => {
    const orderDate = dayjs();
    const purchaseOrderDate = dayjs();
    const deliveryDate = orderDate.clone().add(12, 'days');
    form.setFieldsValue({
      order_date: orderDate,
      delivery_date: deliveryDate,
      purchase_order_date: purchaseOrderDate,
    });
  }, [form]);

  const disablePastDates = current => {
    const currentOrderDate = form.getFieldValue('order_date') || moment();
    return (
      current && current < moment.max(moment().startOf('day'), currentOrderDate)
    );
  };
  const { data: packingModeList, loading: packingModeLoading } = useSelector(state => state.packingMode);
  const { list: alloyList, loading: alloyLoading } = useSelector(state => state.alloy);
  const { list: temperList, loading: temperLoading } = useSelector(state => state.temper);
  const { jobWorkdata, loading: jobWorkLoading } = useSelector(state => state.jobWork);


  useEffect(() => {
    dispatch(resetPackingModeData());
    dispatch(resetAlloyList());
    dispatch(resetTempersList());
    dispatch(resetCurrentTemperPage());
    dispatch(resetJobWorkList());
    dispatch(fetchPackingModeList({ page: 1, pagesize: 100 }));
    dispatch(fetchAlloysList({ page: 1, pagesize: 1000 }));
    dispatch(fetchTempersList({ page: 1, pagesize: 1000 }))
    dispatch(fetchjobWorkList());
  }, [dispatch]);



  useEffect(() => {
    const fetchQuotation = async () => {
      try {
        dispatch(fetchInquiryQuotationById(id))
          .unwrap()
          .then(response => {
            if (response) {

              const quotationData = response?.data;

              if (quotationData) {
                const quotationDetails = quotationData.inquiry_quotation_details.map((detail) => ({
                  id: detail.id || null,
                  section_no: detail?.section_no,
                  alloy: detail?.alloy,
                  temper: detail.temper,
                  length: detail.length,
                  quantity: detail?.quantity,
                  conversion: detail?.conversion,
                  packing_cost: detail?.packing_cost,
                  surface_finish: detail.surface_finish,
                  cutting: detail.cutting,
                  cutting_price: detail?.cutting_price,
                  machining: detail.machining || false,
                  machining_price: detail?.machining_price,
                  deburring: detail.deburring || false,
                  deburring_price: detail.deburring_price || undefined,
                  anodising: detail.anodising || false,
                  anodising_description: detail.anodising_description || undefined,
                  anodising_price: detail.anodising_price || undefined,
                  powder_coating: detail.powder_coating || false,
                  powder_coating_description: detail.powder_coating_description || undefined,
                  powder_coating_price: detail.powder_coating_price || undefined,
                  pvdf: detail.pvdf || false,
                  pvdf_description: detail.pvdf_description || undefined,
                  pvdf_price: detail.pvdf_price || undefined,
                }));

                const formValues = {
                  customer_name: quotationData.customer_name,
                  sales_order_details: quotationDetails,
                  quotation_date: dayjs()
                };

                form.setFieldsValue(formValues);
              }
            }
          })
          .catch(error => {
            console.error(error);
          });
      } catch (error) {
        console.error('');
      }
    };

    fetchQuotation();
  }, [id, form, dispatch]);

  const handleFinish = async values => {



    const formattedValues = {
      ...values,
      order_date: dayjs(values.order_date).format('YYYY-MM-DD'),
      purchase_order_date: dayjs(values.purchase_order_date).format(
        'YYYY-MM-DD',
      ),

    };

  

    dispatch(convertToSalesOrder({ id, values: formattedValues }))
      .unwrap()
      .then(result => {
        if (result.success) {
          message.success('Sales Order Created Successfully!');
          navigate('/sales-order-list');
        }
      })
      .catch(error => {
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }
          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error);
        } else if (error instanceof Error) {
          message.error(error.message);
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };


  return (
    <>
      <div className="sticyaction">
        <div className="pagenamerow">
          <h2>Create Sales Order</h2>
          <div className="bredcrumbwrp">
            <Link to="/sales-order-list" className="back">
              <Back /> BACK
            </Link>
            <Breadcrumb
              items={[
                { title: <Link to="/dashboard">Home</Link> },
                { title: <Link to="/sales-order-list">Sales Orders</Link> },
                { title: 'Create Sales Order' },
              ]}
            />
          </div>
        </div>
      </div>
      <div className="formwrapper">
        <Form
          form={form}
          layout="vertical"
          onFinish={handleFinish}
          autoComplete="off"
          initialValues={{
            purchase_order_copy: [],
          }}
        >
          <div className="formrowsection">
            <Row gutter={16}>
              <Col xs={24} sm={12} xl={8} xxl={5}>
                <Form.Item
                  name="customer_name"
                  label="Customer Name"
                  rules={[{ required: true, message: 'Please select customer' }]}
                >
                  <Input placeholder="Enter customer name" readOnly />
                </Form.Item>
              </Col>


              <Col xs={12} sm={6} xl={3}>
                <Form.Item
                  name="order_date"
                  label="Order Date"
                  rules={[
                    { required: true, message: 'Please select order date' },
                  ]}
                >
                  <DatePicker
                    style={{ width: '100%' }}
                    format="DD-MM-YYYY"
                    defaultValue={moment()}
                    disabled
                    disabledDate={current =>
                      current && current.isAfter(dayjs(), 'day')
                    }
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} xl={8} xxl={4}>
                <Form.Item
                  name="purchase_order_number"
                  label="Purchase Order No"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter valid purchase order no',
                    },
                  ]}
                >
                  <Input placeholder="Enter purchase order no." />
                </Form.Item>
              </Col>
              <Col xs={24} sm={12} xl={8} xxl={3}>
                <Form.Item
                  name="purchase_order_date"
                  label="Purchase Order Date"
                  rules={[
                    {
                      required: true,
                      message: 'Please select purchase order date',
                    },
                  ]}
                >
                  <DatePicker
                    style={{ width: '100%' }}
                    format="DD-MM-YYYY"
                    disabledDate={current =>
                      current && current.isAfter(dayjs(), 'day')
                    }
                  />
                </Form.Item>
              </Col>
              <Col xs={12} md={8} xl={6} xxl={6}>
                <Form.Item
                  name="packing_mode"
                  label="Mode Of Packing"
                  rules={[
                    { required: true, message: 'Please select mode of packing' },
                  ]}
                >
                  <AutoOpenSelect
                    placeholder="Select Mode Of Packing"
                    options={Array.from(
                      new Map(
                        packingModeList.map(item => [item.id, { label: item.name, value: item.id }])
                      ).values()
                    )}
                    mode="multiple"
                  />
                </Form.Item>

              </Col>

              <Col xs={24} sm={24} lg={12} xxl={12}>
                <Form.Item name="remarks" label="Remarks">
                  <Input.TextArea
                    placeholder="Enter remarks"
                    onChange={e => {
                      const value = e.target.value;

                      const formattedValue =
                        value.trim() === ''
                          ? null
                          : value
                            .toLowerCase()
                            .replace(/\b\w/g, char => char.toUpperCase());

                      form.setFieldsValue({ remarks: formattedValue });
                    }}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={8} xl={6}>
                <Form.Item
                  name="purchase_order_copy"
                  label="Purchase Order Copy"
                  valuePropName="fileList"
                  getValueFromEvent={(e) => e?.fileList || []}
                  rules={[
                    {
                      required: true,
                      message: 'Please upload a purchase order copy file'
                    },
                    {
                      validator: (_, fileList) => {
                        // If no files uploaded, it's valid (since field is not required)
                        if (!fileList || fileList.length === 0) {
                          return Promise.resolve();
                        }

                        const allowedExtensions = /\.(pdf|jpe?g|png)$/i;

                        for (let file of fileList) {
                          // Check file name from either originFileObj or file itself
                          const fileName = file?.originFileObj?.name || file.name;

                          if (!allowedExtensions.test(fileName)) {
                            return Promise.reject(
                              new Error("Only PDF, JPEG, JPG, or PNG files are allowed")
                            );
                          }
                        }

                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Upload
                    name="file"
                    listType="picture"
                    accept=".pdf,.jpeg,.jpg,.png"
                    maxCount={1}
                    beforeUpload={() => false}
                    onChange={(info) => {
                      // const allowedExtensions = /\.(pdf|jpe?g|png)$/i;
                      // const file = info.fileList[info.fileList.length - 1];

                      // if (file) {
                      //   const fileName = file?.originFileObj?.name || file.name;

                      //   if (!allowedExtensions.test(fileName)) {
                      //     message.error("Only PDF, JPEG, JPG, or PNG files are allowed");
                      //     // Don't update the form field with invalid file
                      //     return;
                      //   }
                      // }

                      // Update form field and trigger validation
                      form.setFieldValue("purchase_order_copy", info.fileList);
                      form.validateFields(['purchase_order_copy']);
                    }}>
                    <Button icon={<UploadOutlined />}>Upload</Button>
                  </Upload>
                  <label className="filenote">
                    Upload PDF, JPEG, JPG or PNG file
                  </label>
                </Form.Item>
              </Col>
            </Row>
          </div>

          <div className="formrowsection">
            <h3 className="rowsubtitle">Add New Item</h3>
            <Form.List name="sales_order_details">
              {(fields, { add, remove }) => (
                <>
                  {fields.map(({ key, name, ...restField }, index) => (
                    <>

                      <Row
                        gutter={[24, 24]}
                        className="rowItem mx-0"
                        align="middle"
                        key={key}
                        wrap={false}
                        style={{ width: '100%' }}
                      >
                        <Col flex="auto">
                          <Row gutter={[16]} key={key}>
                            <Col xs={12} md={8} xl={6} xxl={3}>
                              <Form.Item
                                {...restField}
                                name={[name, 'section_no']}
                                label="Section Number"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please select a profile number',
                                  },
                                ]}
                              >
                                <Input placeholder="Enter Section No" readOnly />
                              </Form.Item>
                            </Col>

                            <Col xs={12} md={8} xl={6} xxl={3}>
                              <Form.Item
                                {...restField}
                                name={[name, 'alloy']}
                                label="Alloy"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please select alloy',
                                  },
                                ]}
                              >
                                <AutoOpenSelect
                                  placeholder="Select Alloy"
                                  loading={alloyLoading}
                                  notFoundContent={
                                    alloyLoading ? 'Loading...' : 'No options'
                                  }
                                  value={
                                    form.getFieldValue([
                                      'sales_order_details',
                                      name,
                                      'alloy',
                                    ])
                                      ? {
                                        value: form.getFieldValue([
                                          'sales_order_details',
                                          name,
                                          'alloy',
                                        ]),
                                        label: '',
                                      }
                                      : undefined
                                  }
                                  onChange={value => {
                                    form.setFieldValue(
                                      ['sales_order_details', name, 'alloy'],
                                      value,
                                    );

                                  }}
                                  disabled
                                  allowClear
                                  showSearch={true}
                                  filterOption={(input, option) => {
                                    if (!input) return true;
                                    const optionText = (option?.children || '')
                                      .toString()
                                      .replace(/\s+/g, '')
                                      .toLowerCase();
                                    const inputText = input
                                      .replace(/\s+/g, '')
                                      .toLowerCase();
                                    return optionText.includes(inputText);
                                  }}
                                  dropdownRender={menu => <>{menu}</>}
                                >
                                  {[
                                    ...new Map(
                                      alloyList.map(item => [item.id, item]),
                                    ).values(),
                                  ].map((el, index) => (
                                    <Option
                                      key={el.id}
                                      value={el.id}
                                      disabled={el.deleted === 1}
                                    >
                                      {el.name} - {el.color_code}
                                    </Option>
                                  ))}
                                </AutoOpenSelect>
                              </Form.Item>
                            </Col>
                            <Col xs={12} md={8} xl={6} xxl={3}>
                              <Form.Item
                                {...restField}
                                name={[name, 'temper']}
                                label="Temper"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please select temper',
                                  },
                                ]}
                              >
                                <AutoOpenSelect
                                  placeholder="Select Temper"
                                  loading={temperLoading}

                                  value={
                                    form.getFieldValue([
                                      'sales_order_details',
                                      name,
                                      'temper',
                                    ])
                                      ? {
                                        value: form.getFieldValue([
                                          'sales_order_details',
                                          name,
                                          'temper',
                                        ]),
                                        label: '',
                                      }
                                      : undefined
                                  }
                                  onChange={value => {
                                    form.setFieldValue(
                                      ['sales_order_details', name, 'temper'],
                                      value,
                                    );

                                  }}
                                  filterOption={(input, option) => {
                                    if (!input) return true;
                                    const optionText = (option?.children || '')
                                      .toString()
                                      .replace(/\s+/g, '')
                                      .toLowerCase();
                                    const inputText = input
                                      .replace(/\s+/g, '')
                                      .toLowerCase();
                                    return optionText.includes(inputText);
                                  }}
                                  disabled
                                  allowClear
                                  showSearch={true}
                                  notFoundContent={
                                    temperLoading ? 'Loading...' : 'No options'
                                  }
                                  dropdownRender={menu => <>{menu}</>}
                                >
                                  {[
                                    ...new Map(
                                      temperList.map(item => [item.id, item]),
                                    ).values(),
                                  ].map((el, index) => (
                                    <Option
                                      key={el.id}
                                      value={el.id}
                                      disabled={el.deleted === 1}
                                    >
                                      {el.name} - {el.code}
                                    </Option>
                                  ))}
                                </AutoOpenSelect>
                              </Form.Item>
                            </Col>

                            <Col>
                              <Form.Item
                                {...restField}
                                name={[name, 'length']}
                                label="Length (mm)"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please enter length',
                                  },
                                ]}
                              >
                                <Input
                                  maxLength={6}
                                  placeholder="0"
                                  readOnly
                                  style={{ width: '100px' }}
                                />
                              </Form.Item>
                            </Col>
                            <Col>
                              <Form.Item
                                {...restField}
                                name={[name, 'pieces']}
                                label="Pieces"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please enter pieces',
                                  },
                                  {
                                    validator: (_, value) => {
                                      if (!value) return Promise.reject('Please enter number of pieces');
                                      const num = Number(value);

                                      if (!Number.isInteger(num))
                                        return Promise.reject('Pieces must be an integer');

                                      if (num <= 0)
                                        return Promise.reject('Pieces must be greater than zero');

                                      if (num > 100000)
                                        return Promise.reject('Pieces cannot exceed 100,000');

                                      return Promise.resolve();
                                    },
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="0"
                                  style={{ width: '100px' }}
                                />
                              </Form.Item>
                            </Col>

                            <Col>
                              <Form.Item
                                {...restField}
                                name={[name, 'quantity']}
                                label="Quantity (kg)"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please enter quantity',
                                  },
                                  {
                                    validator: (_, value) => {
                                      if (value === undefined || value === null || value === '')
                                        return Promise.reject('Please enter quantity');

                                      const num = Number(value);

                                      if (isNaN(num))
                                        return Promise.reject('quantity must be a valid number');

                                      if (num <= 0)
                                        return Promise.reject('quantity must be greater than zero');

                                      if (num > 10000)
                                        return Promise.reject('quantity cannot exceed 10,000 kg');

                                      // Allow up to 2 decimal places
                                      if (!/^\d+(\.\d{1,3})?$/.test(value))
                                        return Promise.reject('Maximum 3 decimal places allowed');

                                      return Promise.resolve();
                                    },
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="0.0"
                                  style={{ width: '100px' }}
                                />
                              </Form.Item>
                            </Col>

                            <Col xs={12} sm={8} xl={2}>
                              <Form.Item
                                {...restField}
                                name={[name, 'conversion']}
                                label="Conversion"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please enter valid Conversion',
                                  },
                                ]}
                              >
                                <Input placeholder="0.0" />
                              </Form.Item>
                            </Col>

                            <Col xs={12} sm={8} xl={3}>
                              <Form.Item
                                {...restField}
                                name={[name, 'packing_cost']}
                                label="Packing Cost"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please enter valid Conversion',
                                  },
                                ]}
                              >
                                <Input placeholder="0.0" />
                              </Form.Item>
                            </Col>
                            <Col xs={12} md={8} xl={6} xxl={3}>
                              <Form.Item
                                {...restField}
                                label="Surface Finish"
                                name={[name, 'surface_finish']}
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please select surface finish',
                                  },
                                ]}
                              >
                                <AutoOpenSelect
                                  placeholder="Select Surface Finish"
                                  mode="multiple"
                                  value={form.getFieldValue([
                                    'sales_order_details',
                                    name,
                                    'surface_finish',
                                  ])}
                                  allowClear
                                  showSearch
                                  disabled
                                  optionFilterProp="children"
                                  onChange={value => {
                                    form.setFieldValue(
                                      ['sales_order_details', name, 'surface_finish'],
                                      value,
                                    );

                                  }}
                                  dropdownRender={menu => <>{menu}</>}
                                >
                                  {jobWorkdata?.map(item => (
                                    <Option key={item.id} value={item.id}>
                                      {item.name}
                                    </Option>
                                  ))}
                                </AutoOpenSelect>
                              </Form.Item>
                            </Col>

                            <Form.Item
                              shouldUpdate={(prevValues, currentValues) =>
                                prevValues.sales_order_details?.[index]?.surface_finish !==
                                currentValues.sales_order_details?.[index]?.surface_finish
                              }
                              noStyle
                            >
                              {({ getFieldValue }) => {
                                const selectedSurfaceFinish = getFieldValue(["sales_order_details", index, "surface_finish"]) || [];

                                const selectedItems = jobWorkdata?.filter(item => selectedSurfaceFinish.includes(item.id));


                                // Example: show conditional field if Laser Marking selected
                                const hasEngineering = selectedItems.some(item => item.name === "Engineering");
                                const hasSurfaceTreatment = selectedItems.some(item => item.name === "Surface treatment");

                                return (
                                  <>
                                    {/* --- Engineering Fields --- */}
                                    {hasEngineering && (
                                      <>
                                        <Form.Item
                                          noStyle
                                          shouldUpdate={(prev, curr) =>
                                            prev.sales_order_details?.[index]?.cutting !== curr.sales_order_details?.[index]?.cutting ||
                                            prev.sales_order_details?.[index]?.machining !== curr.sales_order_details?.[index]?.machining ||
                                            prev.sales_order_details?.[index]?.deburring !== curr.sales_order_details?.[index]?.deburring
                                          }
                                        >
                                          {({ getFieldValue }) => {
                                            const cutting = getFieldValue(['sales_order_details', index, 'cutting']);
                                            const machining = getFieldValue(['sales_order_details', index, 'machining']);
                                            const deburring = getFieldValue(['sales_order_details', index, 'deburring']);

                                            return (
                                              <>
                                                {cutting && (
                                                  <Col xs={12} md={8} xl={3}>
                                                    <Form.Item
                                                      label="Cutting Price"
                                                      name={[name, 'cutting_price']}
                                                      rules={[{ required: true, message: 'Enter Cutting Price' }]}
                                                    >
                                                      <Input placeholder="0.0" />
                                                    </Form.Item>
                                                  </Col>
                                                )}

                                                {machining && (
                                                  <Col xs={12} md={8} xl={3}>
                                                    <Form.Item
                                                      label="Machining Price"
                                                      name={[name, 'machining_price']}
                                                      rules={[{ required: true, message: 'Enter Machining Price' }]}
                                                    >
                                                      <Input placeholder="0.0" />
                                                    </Form.Item>
                                                  </Col>
                                                )}

                                                {deburring && (
                                                  <Col xs={12} md={8} xl={3}>
                                                    <Form.Item
                                                      label="Deburring Price"
                                                      name={[name, 'deburring_price']}
                                                      rules={[{ required: true, message: 'Enter Deburring Price' }]}
                                                    >
                                                      <Input placeholder="0.0" />
                                                    </Form.Item>
                                                  </Col>
                                                )}
                                              </>
                                            );
                                          }}
                                        </Form.Item>
                                      </>
                                    )}
                                    {/* --- Surface Treatment Fields --- */}
                                    {hasSurfaceTreatment && (
                                      <>


                                        {/* Nested conditional price fields */}
                                        <Form.Item
                                          noStyle
                                          shouldUpdate={(prev, curr) =>
                                            prev.sales_order_details?.[index]?.anodising !== curr.sales_order_details?.[index]?.anodising ||
                                            prev.sales_order_details?.[index]?.powder_coating !== curr.sales_order_details?.[index]?.powder_coating ||
                                            prev.sales_order_details?.[index]?.pvdf !== curr.sales_order_details?.[index]?.pvdf
                                          }
                                        >
                                          {({ getFieldValue }) => {
                                            const anodising = getFieldValue(["sales_order_details", index, "anodising"]);
                                            const powder_coating = getFieldValue(["sales_order_details", index, "powder_coating"]);
                                            const pvdf = getFieldValue(["sales_order_details", index, "pvdf"]);
                                            return (
                                              <>
                                                {anodising && (
                                                  <Col xs={12} md={8} xl={3}>
                                                    <Form.Item
                                                      label="Anodising Price"
                                                      name={[name, "anodising_price"]}
                                                      rules={[{ required: true, message: "Enter Anodising Price" }]}
                                                    >
                                                      <Input placeholder="Enter Anodising Price" />
                                                    </Form.Item>
                                                  </Col>
                                                )}

                                                {powder_coating && (
                                                  <Col xs={12} md={8} xl={3}>

                                                    <Form.Item
                                                      label="Powder Coating Price"
                                                      name={[name, "powder_coating_price"]}
                                                      rules={[{ required: true, message: "Enter Powder Coating Price" }]}
                                                    >
                                                      <Input placeholder="Enter Powder Coating Price" />
                                                    </Form.Item>

                                                  </Col>
                                                )}

                                                {pvdf && (
                                                  <Col xs={12} md={8} xl={3}>

                                                    <Form.Item
                                                      label="PVDF Price"
                                                      name={[name, "pvdf_price"]}
                                                      rules={[{ required: true, message: "Enter PVDF Price" }]}
                                                    >
                                                      <Input placeholder="Enter PVDF Price" />
                                                    </Form.Item>

                                                  </Col>
                                                )}
                                              </>
                                            );
                                          }}
                                        </Form.Item>
                                      </>
                                    )}
                                  </>
                                );
                              }}
                            </Form.Item>

                          </Row>
                        </Col>
                        <Col>
                          <div className="addwrp">
                            {/* {index !== 0 && (
                              <Button
                                type="primary"
                                danger
                                icon={<MinusCircleOutlined />}
                                onClick={() => remove(name)}
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                }}
                              />
                            )} */}
                          </div>
                        </Col>
                      </Row>
                    </>
                  ))}
                  {/* <Form.Item>
                    <div className="w-100 flex justify-end ">
                      <Button
                        type="primary"
                        onClick={() => {
                          if (fields.length < 500) {

                            add();
                          } else {
                            message.error('You can only add up to 15 records.');
                          }
                        }}
                        icon={<PlusOutlined />}
                      >
                        Add Item
                      </Button>
                    </div>
                  </Form.Item> */}
                </>
              )}
            </Form.List>
          </div>
          <div className="flex justify-end">
            <Button
              type="primary"
              htmlType="submit"
              icon={<PlusOutlined />}
            //loading={btnLoading}
            >
              Create Sales Order
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
}

export default ConvertToSalesOrder;
